import cn from 'classnames';
import type { PlatformCompany } from '../../../../types';
import type { CompanyRowDisplayFlags } from '../types';
import { HeaderBlock, CertBlock, PriceBlock, TagsBlock } from '../row-blocks';

export interface AliIntlCompanyCardProps {
  company: PlatformCompany;
  displayFlags: CompanyRowDisplayFlags;
  className?: string;
}

/**
 * AliIntlCompanyCard — 阿里国际（ALI_INTL）供应商卡片
 *
 * 中部区块展示：商品图 + 价格/MOQ + 统计数据（On-time / Resp）
 */
export function AliIntlCompanyCard({ company, displayFlags, className }: AliIntlCompanyCardProps) {
  const { showCertSection, showPriceSection, showStatsSection, showTagsSection } = displayFlags;
  const showMiddleSection = showPriceSection || showStatsSection;

  return (
    <div className={cn('bg-white rounded-lg p-3 h-full', className)}>
      {/* 区块1：头部 */}
      <HeaderBlock company={company} />

      {/* 区块2：认证标签行 */}
      <CertBlock show={showCertSection} certList={company.certList} />

      {/* 区块3：价格信息 */}
      <PriceBlock
        show={showMiddleSection}
        company={company}
        showPriceSection={showPriceSection}
        showStatsSection={showStatsSection}
      />

      {/* 水平分隔线 */}
      {showMiddleSection && showTagsSection && <div className="border-t border-[#F0F0F0]" />}

      {/* 区块4：底部能力标签 */}
      <TagsBlock show={showTagsSection} tagList={company.tagList} />
    </div>
  );
}
